import { Controller } from "@hotwired/stimulus"

// Submits the closest form when Enter is pressed.
// Shift+Enter inserts a newline as normal.
//
// Usage: add this controller to a textarea and wire the keydown event:
//   data-controller="components--submit-on-enter"
//   data-action="keydown->components--submit-on-enter#submit"
export default class extends Controller {
  submit(event) {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault()
      this.element.closest("form").requestSubmit()
    }
  }
}
